import React, { useEffect, useState } from "react"
import Helmet from "react-helmet"
import Seo from "components/seo"
import Layout from "components/layout"
import ResultProductPage from "@components/pages/result/result-product"
import BlankState from "components/pages/wishlist/blank-state"
import icoBlank from "assets/img/icon/ico_add-cart-light.svg"

//Utils
import { F_Q_SEARCH } from "lib/function"
import { TokenValidation } from "lib/function/token-validation"

import { useRouter } from "next/router"
import { Pagination } from "@components/anti"
import { showOption, sortOption } from "lib/utils/constant"
import InfiniteScroll from "react-infinite-scroll-component"

const SearchResultPage = ({
  data,
  wishlists,
  slug,
  type,
  pagination,
  locale,
  limit,
  sort,
  token,
}) => {
  const Router = useRouter()

  //States *********************************************************** //
  const [state, setState] = React.useState({
    isBlank: data?.length == 0 ? true : false,
    sort: sort ?? "created_at-desc",
    show: limit ?? "",
    page: 2,
  })

  const [result, setResult] = useState(data)
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      isBlank: data?.length == 0 ? true : false,
    }))

    setResult(data)
  }, [data])

  const handleChangePage = (val) => {
    Router.query.page = val
    Router.push(Router)
  }

  useEffect(() => {
    const { sort, limit, page } = Router.query
    setState((prev) => ({
      ...prev,
      sort: sort ?? "created_at-desc",
      show: limit ?? "",
      page: page ?? 2,
    }))
  }, [Router.query.slug])

  const handleChangeSort = (e) => {
    setState((prev) => ({ ...prev, sort: e.target.value, page: 2 }))
    Router.query.sort = e.target.value
    delete Router.query.page
    Router.push(Router)
  }

  const handleChangeShow = (e) => {
    setState((prev) => ({ ...prev, show: e.target.value, page: 2 }))
    if (e.target.value === "") {
      delete Router.query.limit
    } else {
      Router.query.limit = e.target.value
    }
    delete Router.query.page
    Router.push(Router)
  }

  const getData = async () => {
    let { data, errors } = await F_Q_SEARCH(
      {
        lang: locale,
        s: type,
        page: state.page,
        limit: 10,
        sort: state.sort,
      },
      token
    )
    setState((prev) => ({ ...prev, page: prev.page + 1 }))
    setResult((prev) => [...prev, ...data?.catalogs?.products])
  }

  return (
    <>
      <Seo title="Result" />
      <Helmet>
        <body className="bd-search-result" />
      </Helmet>

      <Layout>
        {state.isBlank ? (
          <div className="pt-4">
            <BlankState
              title={
                locale === "id"
                  ? "Produk tidak ditemukan"
                  : "Products not found"
              }
              icon={icoBlank}
            />
          </div>
        ) : (
          <>
            <section className="sc-search-result">
              <div className="container">
                <div className="btn-back-wrapper">
                  <span
                    className="ail ai-arrow-left font-weight-bold"
                    style={{ cursor: "pointer" }}
                    onClick={() => Router.back()}
                  />
                </div>

                <div className="sort-wrapper">
                  <div className="sort-content-wrapper">
                    <div className="wrapper-select">
                      <h6 className="label-select">
                        {locale === "id" ? "Lihat" : "Show"}:
                      </h6>
                      <div className="wrapper-field-select">
                        <select
                          value={state.show}
                          onChange={handleChangeShow}
                          className="custom-select-category"
                        >
                          {showOption(locale).map(({ label, value }, i) => (
                            <option value={value} key={i}>
                              {label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="wrapper-select">
                      <h6 className="label-select">
                        {locale === "id" ? "Urutan" : "Sort"}:
                      </h6>
                      <div className="wrapper-field-select">
                        <select
                          value={state.sort}
                          onChange={handleChangeSort}
                          className="custom-select-category"
                        >
                          {sortOption(locale).map(({ label, value }, i) => (
                            <option value={value} key={i}>
                              {label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                {state.show === "" ? (
                  <InfiniteScroll
                    dataLength={result?.length}
                    next={getData}
                    hasMore={state.page <= pagination.last_page}
                    loader={
                      <div className="text-center py-5">
                        <h6>Loading....</h6>
                      </div>
                    }
                    scrollThreshold="1000px"
                  >
                    <ResultProductPage data={result} wishlists={wishlists} />
                  </InfiniteScroll>
                ) : (
                  <ResultProductPage data={result} wishlists={wishlists} />
                )}
                {pagination && state.show && (
                  <div className="container">
                    <div className="d-flex justify-content-end">
                      <Pagination
                        count={pagination.last_page}
                        onChange={handleChangePage}
                        page={pagination.current_page}
                      />
                    </div>
                  </div>
                )}
              </div>
            </section>
          </>
        )}
      </Layout>
    </>
  )
}

export default SearchResultPage

export const getServerSideProps = async (ctx) => {
  let { token } = await TokenValidation(ctx)
  let { page, sort, limit, type } = ctx.query
  let { locale } = ctx
  // let wishlists = await F_Q_WISHLIST({ lang: locale }, token)
  let { data, errors } = await F_Q_SEARCH(
    {
      lang: locale,
      s: type ?? "",
      page: page ?? 1,
      limit: limit ?? 10,
      sort: sort ?? "created_at-desc",
    },
    token
  )
  if (data) {
    return {
      props: {
        data: data.catalogs.products ?? [],
        type,
        locale,
        // wishlists: wishlists?.data,
        pagination: data.catalogs.pagination,
        limit: limit ?? "",
        sort: sort ?? "created_at-desc",
        token,
      },
    }
  } else return { notFound: true }
}
